import { SubCategory, Image } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { SubCategoryImageEntityConfig } from "./config";
import { SubCategoryImageFilters } from "./filters";
import { SubCategoryImageMethods } from "./methods";

@HyperEntity("sub-category-image", SubCategoryImageEntityConfig)
export class SubCategoryImage extends extender(
  SubCategoryImageFilters,
  SubCategoryImageMethods,
) {
  @Fields.string({ dbName: "sub_category_id" })
  subCategoryId = "";

  @Fields.string({ dbName: "image_id" })
  imageId = "";

  @Relations.toOne(() => SubCategory, "subCategoryId")
  subCategory?: SubCategory;

  @Relations.toOne(() => Image, "imageId")
  image?: Image;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}

